"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DebugLogger = void 0;
const enums_1 = require("./enums");
class DebugLogger {
    constructor(debugMode = false, minLevelInclusive = enums_1.LogLevel.Debug) {
        this.setDebugMode(debugMode, minLevelInclusive);
    }
    /**
     * Constructs a DebugLogger instance.
     * @param {boolean} [debugMode=false] - Whether debug mode is on or off.
     * @param {LogLevel} [minLevelInclusive=LogLevel.debug] - Minimum log level to display logs for.
     * Example usage: If you want to see warnings and errors only and not a flood of debug logs, set minLevelInclusive to LogLevel.warning.
     */
    static getInstance(debugMode = false, minLevelInclusive = enums_1.LogLevel.Debug) {
        if (!DebugLogger.instance) {
            DebugLogger.instance = new DebugLogger(debugMode, minLevelInclusive);
        }
        return DebugLogger.instance;
    }
    setDebugMode(initialDebugMode, initialMinLevelInclusive) {
        let storedDebugMode = false;
        let storedLogLevel = enums_1.LogLevel.Debug;
        if (typeof localStorage !== 'undefined') {
            try {
                storedDebugMode = localStorage.getItem('inspiredDebugMode') === 'true';
                const logLevelString = localStorage.getItem('inspiredLogLevel');
                storedLogLevel = logLevelString ? +logLevelString : enums_1.LogLevel.Debug;
            }
            catch (error) {
                console.warn("Failed to retrieve DebugLogger values from local storage:", error);
            }
        }
        else {
            console.warn("Local storage is not available in this environment.");
        }
        DebugLogger.debugMode = initialDebugMode || storedDebugMode;
        DebugLogger.minLevelInclusive = initialMinLevelInclusive || storedLogLevel;
    }
    static toggleDebugMode(on) {
        DebugLogger.debugMode = on;
        localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem('inspiredDebugMode', String(on));
    }
    static setLogLevel(logLevel) {
        DebugLogger.minLevelInclusive = logLevel;
        localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem('inspiredLogLevel', enums_1.LogLevel[logLevel]);
    }
    debug(message, extraContent) {
        if (this.shouldLog(enums_1.LogLevel.Debug)) {
            console.log('%c DEBUG: ' + message, 'background: #d9f2d9; color: #000', ...(extraContent !== undefined ? [extraContent] : []));
        }
    }
    warning(message, extraContent) {
        if (this.shouldLog(enums_1.LogLevel.Warning)) {
            console.log('%c WARNING: ' + message, 'background: #ffffb3; color: #000', ...(extraContent !== undefined ? [extraContent] : []));
        }
    }
    error(message, errorData) {
        if (this.shouldLog(enums_1.LogLevel.Error)) {
            const error = {
                name: 'CustomError',
                message: message,
                stack: (errorData === null || errorData === void 0 ? void 0 : errorData.stack) || null,
                url: window.location.href,
                userAgent: navigator === null || navigator === void 0 ? void 0 : navigator.userAgent,
                context: {
                    originalError: errorData
                }
            };
            console.log('%c ERROR: ' + message, 'background: #FF0000', ...(errorData !== undefined ? [errorData] : []));
        }
    }
    shouldLog(level) {
        return DebugLogger.debugMode && DebugLogger.minLevelInclusive <= level;
    }
}
exports.DebugLogger = DebugLogger;
DebugLogger.debugMode = false;
